import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import brandingConfig from '../../config/brandingConfig';

const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '200px',
  width: '100%',
  '& .MuiCircularProgress-root': {
    color: brandingConfig.colors.primary,
  },
}));

const LoadingMessage = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

const Loading = ({ message = 'Daten werden geladen...' }) => {
  return (
    <LoadingContainer>
      <CircularProgress size={60} thickness={5} />
      <LoadingMessage variant="h6">{message}</LoadingMessage>
    </LoadingContainer>
  );
};

export default Loading;